import './package.scss';

import { Outlet } from "react-router-dom";

import { FilterPackageProvider } from "./filter-package/filter-package.context";

export function Package() {
  return (
    <div id="ShellPackage" className="package">
       <FilterPackageProvider>
        <Outlet />
      </FilterPackageProvider>
    </div>
  );
}

export default Package;
